<template>
  <h2
    class="px-4 sm:px-0 text-secondaryPalette font-medium text-base sm:text-lg md:text-base lg:text-base break-words leading-snug"
  >
    {{ getSection }}
  </h2>
</template>

<script>
export default {
  props: {
    getModule: String,
    getSection: String,
    getSectionId: String
  }
};
</script>
